import React, { FC, useCallback } from 'react';
import { Button, Grid } from '@mui/material';
import { useStyles } from './ProviderOptions.style';

interface ProviderOptionsProps {
  options: { label: string; value: string }[];
  selected: string;
  onChange: (value: string) => void;
  isDisabled: boolean;
}

export const ProviderOptions: FC<ProviderOptionsProps> = ({
  options,
  selected,
  onChange,
  isDisabled,
}) => {
  const { classes } = useStyles();

  const onOptionClick = useCallback(
    (value) => {
      onChange(value);
    },
    [onChange]
  );

  return (
    <Grid container spacing={1}>
      {options.map(({ label, value }) => (
        <Grid item xs={12 / options.length} key={value}>
          <Button
            className={classes.button}
            size="medium"
            color="primary"
            variant={selected === value ? 'contained' : 'outlined'}
            fullWidth
            onClick={() => onOptionClick(value)}
            disabled={isDisabled}
          >
            {label}
          </Button>
        </Grid>
      ))}
    </Grid>
  );
};
